<template>
 <section >
      <div class="container-fluid">
        <div class="w80">
          <div class="row" >
            <div class="col-sm-12 col-md-6 " >
                  <div class="row align-items-center">
                      <div class="col-sm-12 noPadding noMargin center" >
                        <div :class="['embed-post',{'bBlanco':item.entrada=='FB'}]">
                            <div class="fb-post" v-if="post_url!='' && item.entrada=='FB'" :data-href="post_url" data-show-text="true" data-allowfullscreen="true"></div>
                            <Tweet :id="tweet" v-if="item.entrada=='TW' && tweet!=null" :options="options" error-message="Ups, no pudimos acceder a este Tweet." ></Tweet>
                            <instagram-embed v-if="item.entrada=='I' && post_url!=''" :url="post_url" :maxwidth="600" />
                        </div>
                      </div>
                  </div>
                  <div class="row actions align-items-center"  >
                    <div class="col">
                      <div class="button-container" >
                          <button :class="['accion-video',{'active':like}]" >
                              <svg
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    >
                                    <path
                                      d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 
                                      2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 
                                      2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
                                    />
                              </svg>
                              <span></span>
                          </button>
                          <button :class="['accion-video',{'active':dislike}]" >
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path
                                d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 
                                  2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 
                                  2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
                              />
                            </svg>
                            <span></span>
                          </button>
                          <button :class="['accion-video',{'active':meh}]" >
                            <svg fill="currentColor" aria-hidden="true" focusable="false" stroke="currentColor" data-prefix="fas" data-icon="info-circle" class="svg-inline--fa fa-info-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path  d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path></svg>
                            <span></span>
                          </button>
                      </div><!-- button-container -->
                    </div><!-- col -->
                    <div class="col-auto">
                      <div class="calificacion">
                        <div class="stars">
                          <label
                            v-for="i in 4" 
                            :key="i"
                            :class="stars[i-1]" 
                            :data-tooltip="getTooltip(i)"                            
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z"
                              />
                            </svg>
                        
                          </label>
                          </div><!-- stars -->
                      </div><!-- calificacion -->
                    </div><!-- col-auto -->
                  </div><!-- row actions align-items-center -->
              </div><!-- col-sm-12 col-md-5-->
              <div class="col-sm-12 col-md-6"  >
                <div class="row align-items-center">
                  <div class="col">
                    <div class="user-avatar">
                      <div class="img-avatar" :style="{'background-image': 'url('+pageImg+'),url('+defaultImage+')'}" ></div>
                      <div class="data-avatar">
                        <p class="user-name noticieroName"  >{{item.noticiero_nombre}}</p>
                        <p class="user"> <a class="verde" :href="item.media" target="_blank">@{{item.key_src}}</a></p>
                      </div>
                    </div>
                  </div>
                  <div class="col-auto">
                    <svg class="svgFB "  v-if="item.entrada=='FB'"  width="30px" height="30px" viewBox="0 0 24 24"><path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z" /></svg>
                        <svg class="svgTW"  v-if ="item.entrada=='TW'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px" height="30px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 4500 4500">
                <path d="M0 4579 c-2 -3 160 -224 359 -490 199 -266 622 -832 940 -1257 l578
        -773 -37 -42 c-21 -23 -446 -482 -944 -1020 -498 -539 -907 -983 -908 -988 -2
        -5 85 -9 210 -8 l213 1 70 77 c39 42 401 433 805 870 404 437 746 807 760 823
        l25 29 200 -268 c110 -147 413 -553 673 -901 l474 -632 725 0 c603 0 724 2
        720 13 -3 8 -187 256 -409 553 -222 296 -476 636 -564 754 -89 118 -350 469
        -582 778 -232 310 -422 568 -422 572 0 7 1226 1338 1643 1783 l119 127 -219 0
        -218 -1 -255 -276 c-140 -152 -483 -524 -763 -825 l-507 -548 -615 822 -616
        823 -725 5 c-399 3 -728 2 -730 -1z m1718 -886 c237 -318 603 -807 813 -1088
        210 -280 676 -904 1036 -1385 360 -482 658 -881 663 -888 6 -9 -65 -12 -324
        -12 l-331 0 -656 878 c-1514 2023 -2278 3045 -2287 3060 -6 9 62 12 323 12
        l331 0 432 -577z" /></svg>
                        <svg class="svgInsta" v-if ="item.entrada=='I'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px" height="30px"  preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3z" /></svg>
                  </div>
                </div><!-- row align-items-center -->
                <div class="post-info" >
                  <div class="info-heading">
                    <div class="row align-items-center">
                      <div class="col">
                        <h2 class="tiulo-post">{{item.titulo}}</h2>
                      </div> <!-- col -->
                    </div> <!-- row align-items-center -->
                  </div><!--info-heading-->
                  <div class="content">
                    
                      <p v-html="item.descripcion"></p>
                  </div><!-- content -->
                </div><!--post-info-->

              </div><!-- col-sm-12 col-md-7-->
            </div><!-- row -->
            <br>
            <div class="divider"></div>
            <div class="comentarios">
                <h2>Comentarios</h2>
                <div class="row">
                  <div class="col-sm-12 col-md-6 " style="max-height:300px; overflow:scroll;" v-if="comments.length>0">
                    <div class="noPadding noMargin" style="width:100%" v-for="(comment,index) in comments" :key="comment.key">
                        
                        <div class="inlineBlock noPadding noMargin" style="width:95%;"> 
                            <div v-html="convertString(comment.comentario)"></div>
                            <label class="sub">{{getFecha(comment.created)}}</label>
                        </div>
                    
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6"></div>
                  <div class="col-sm-12 col-md-6" >
                    <div class="button-circle-more secondary" v-if="LastEvaluatedKey">
                      <button class="circle-more" @click="getComments">
                        <svg viewBox="0 0 18 18">
                            <g id="Grupo_29" data-name="Grupo 29" transform="translate(-171 -753)">
                              <rect
                                id="Rectángulo_redondeado_903"
                                data-name="Rectángulo redondeado 903"
                                width="2"
                                height="18"
                                rx="1"
                                transform="translate(179 753)"
                                fill="#fff"
                              />
                              <rect
                                id="Rectángulo_redondeado_903_copia"
                                data-name="Rectángulo redondeado 903 copia"
                                width="18"
                                height="2"
                                rx="1"
                                transform="translate(171 761)"
                                fill="#fff"
                              />
                            </g>
                          </svg>
                        </button>
                        </div>
                      <!-- END BUTTON CIRCLE -->
        
                  </div>

                </div>
            </div><!-- comments -->
            <div class="page-actions"> 
                <button class="button small outline" v-if="from2" @click="goBack">Regresar</button>
            </div>
        </div><!-- div w80-->
      </div>
    </section>
</template>

<script>

import { Tweet } from 'vue-tweet-embed'
import InstagramEmbed from 'vue-instagram-embed';
import { strings } from "@/services/strings.js";

import moment from 'moment-timezone'

export default {
    props:['item','from','fromParams','comments'],
    components: {Tweet,InstagramEmbed},
    mixins: [strings],
    data () {
        return {
            token:this.$store.state.userInfo.token,
            html:"",
            videoId:"",
            pageImg:"",
            post_url:"",
            showText:"true",
            url : this.$store.getters.getMainUrl,
            tweet:null,
            options:{
                align:'center',
                lang:'es',
                width:'350'
            },
            noStars:0,
            stars: ["button small star-video tooltip tooltip-bottom", "button small star-video tooltip tooltip-bottom", "button small star-video tooltip tooltip-bottom", "button small star-video tooltip tooltip-bottom"],
            from2:null,
            like:false,
            dislike:false,
            meh:false,
            defaultImg:"",
            fbVideo:false,
            LastEvaluatedKey:null,
            defaultImage:this.$store.state.defaultNote
        }
    },
    beforeMount(){
        var backData2 = this.$store.state.backData2;
        this.from2 = backData2.length>0?backData2[backData2.length-1].from:null;
        var item = this.item;
        switch(this.item.entrada){
            case 'FB':
                 this.defaultImage = this.$store.state.defaultFacebook;
                this.item.descripcion = this.item.descripcion==undefined? this.item.html.replace(/<(?:.|\n)*?>/gm, ''):this.item.descripcion;
                this.pageImg = this.item.noticiero_img?this.item.noticiero_img:this.$store.state.defaultFacebook;
                
                this.post_url = this.item.media;
                this.fbVideo = this.post_url.includes('videos')? true:false;
                console.log('fbVideo: ',this.fbVideo)
                this.$loadScript("https://connect.facebook.net/en_US/sdk.js")
                .then(() => {
                    this.$nextTick(() => {
                        window.FB.XFBML.parse();
                    });
                })
                .catch(() => {
                    console.log("FB SCRIPT LAODING ERROR");
                });
            break;
            case 'TW':
                this.pageImg = item.noticiero_img?item.noticiero_img:this.$store.state.defaultTwitter;
                var arr = item.media.split('/');
                this.tweet = arr[arr.length-1]; 
                this.defaultImage =  this.$store.state.defaultTwitter;
            break;
            case 'I':
                this.pageImg = item.noticiero_img?item.noticiero_img:this.$store.state.defaultInstagram;
                this.post_url = item.media;
                this.defaultImage = this.$store.state.defaultInstagram;
                this.pageImg = this.item.noticiero_img?this.item.noticiero_img:this.$store.state.defaultInstagram;
                this.item.html = this.item.html? item.html : "";
                this.item.descripcion = this.item.descripcion==undefined? this.item.html.replace(/<(?:.|\n)*?>/gm, ''):this.item.descripcion.replace(/<(?:.|\n)*?>/gm, '');
            break;
        }

        if (this.item.metadatos) {
            var new_item = this.item.metadatos;
            if(new_item.titulo){
            this.$nextTick(function() {
                this.$set(this.item, "titulo", new_item.titulo);
            });
            }

            if(new_item.descripcion){
            this.$nextTick(function() {
                this.$set(this.item, "descripcion", new_item.descripcion);
            });
            }
            
            this.setLikes(new_item.lke);
            this.noStars = new_item.stars ? new_item.stars : this.noStars;
            this.setStars(this.noStars);
        }
        this.item = item;
    },
    mounted(){
        
        this.setStars();
    },
    methods:{
        setStars(){
            this.pintaStars(this.noStars);
        },
        pintaStars(noStars){
            if(noStars!=undefined){
                this.resetStars();
                for(var i=0;i<noStars;i++){
                    this.stars[i] += ' active';
                }
            }
        },
        resetStars(){
            this.stars = ['star','star','star','star'];
        },
        setLike() {
            this.like = true;
            this.dislike = false;
            this.meh = false;
        },
        setDislike() {
            this.like = false;
            this.dislike = true;
            this.meh = false;
        },
        setMeh(){
            this.like = false;
            this.dislike = false;
            this.meh = true;
        },
        setLikes(type){
            switch(type){
                case 0: this.setDislike(); break;
                case 1: this.setLike(); break; 
                case 2: this.setMeh(); break;
            }
        },
        parseFecha(fecha){//fecha= "2020-02-06 16:13:12"
            moment.tz.setDefault('America/Mexico_City');
            
            var tmp = moment(fecha);
        
            var f = moment
                .tz(tmp, "America/Mexico_City")
                // .utc()
                // .local()
                .format("DD/MM/YYYY HH:mm:ss");
                return f;
        },
        getFecha(fecha){
            moment.tz.setDefault('America/Mexico_City');
            var  tmp =  moment(fecha);
            var f = moment.tz(tmp,'America/Mexico_City').format('DD-MM-YYYY HH:mm:ss');
            return f;
        },
        error(msg){
            this.$snotify.error(msg, 'Error');
        },
        success(msg){
            this.$snotify.success(msg, 'Success');
        },
        goBack(){
             var backData2 = this.$store.state.backData2;
           
            var data = backData2.pop();
    
            if(data == undefined) {
                this.$router.back();
            }
            else{
                var from = data.from;
                var params = data.fromParams;
                if(from == 'publicNotas'){
                  this.$router.back();
                }else{
                  this.$router.push({
                      name:from,
                      params:params
                  });
                }
            }
        },
        getTooltip(i){
          var tooltip = "";
          switch(i){
            case 1: tooltip = 'Irrelevante'; break;
            case 2: tooltip = 'Poco Interesante'; break;
            case 3: tooltip = 'Relevante'; break;
            case 4: tooltip = 'Muy Relevante'; break;
            default:break;
          }
          return tooltip;
        },
    }
}
</script>

<style scoped>

.escondido{
  position: absolute; left: -1000px; top: -1000px;
}

.sub {
  color: #00b99e!important;
}

.specialPadding{
  padding: 8px 15px;
}

.back-button {
   padding: 0;
   width: 27px;
   height: 27px;
   border-radius: 5px;
 }

.back-button:hover svg {
   fill: #fff;
 }

</style>